import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { ElectionDetails } from './ElectionDetails';
import { DownloadBallot } from './DownloadBallot';
import { LetterToMembers } from './LetterToMembers';
import { ElectionBallot } from './ElectionBallot';
import { QuickLinks } from './QuickLinks';
export function ElectionPage() {
  return <PageLayout data-id="element-1398">
      <HeaderBanner data-id="element-1399" />
      <ElectionDetails data-id="element-1400" />
      <DownloadBallot data-id="element-1401" />
      <LetterToMembers data-id="element-1402" />
      <ElectionBallot data-id="element-1403" />
      <QuickLinks data-id="element-1404" />
    </PageLayout>;
}